import { LeadCaptureModal } from '@/components/LeadCaptureModal';
import { TermsModal } from '@/components/TermsModal';
import { useState } from 'react';
import { Footer } from './components/Footer';
import { HeroSection } from './components/HeroSection';
import { HowItWorks } from './components/HowItWorks';
import { TargetAudience } from './components/TargetAudience';
import { ValueProposition } from './components/ValueProposition';
import { WhatYouReceive } from './components/WhatYouReceive';

export function LandingPage() {
  const [showLeadModal, setShowLeadModal] = useState(false);
  const [showTermsModal, setShowTermsModal] = useState(false);

  return (
    <main className="min-h-screen">
      <HeroSection onStartDiagnostic={() => setShowLeadModal(true)} />
      <ValueProposition />
      <WhatYouReceive />
      <HowItWorks />
      <TargetAudience />
      <Footer
        onStartDiagnostic={() => setShowLeadModal(true)}
        onOpenTerms={() => setShowTermsModal(true)}
      />

      <LeadCaptureModal open={showLeadModal} onOpenChange={setShowLeadModal} />
      <TermsModal open={showTermsModal} onOpenChange={setShowTermsModal} />
    </main>
  );
}
